function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9999 30C11.9064 30 8.93583 29.0657 6.40954 27.2979C3.94158 25.5711 2.06848 23.1777 0.992675 20.3762C0.33403 18.661 0 16.8522 0 15C0 6.72897 6.72897 0 15 0C23.271 0 30 6.72897 30 15C30 23.271 23.2709 30 14.9999 30ZM14.9999 2.90466C8.3305 2.90466 2.90457 8.33059 2.90457 15C2.90457 16.4948 3.17359 17.9533 3.70414 19.335C5.48681 23.9767 10.0262 27.0953 14.9999 27.0953C21.6693 27.0953 27.0953 21.6694 27.0953 15C27.0953 8.33059 21.6693 2.90466 14.9999 2.90466Z",
  fill: "#C6C6C6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.77192 20.4542C2.43182 20.4542 2.09199 20.3237 1.83388 20.0629C1.32127 19.5448 1.32566 18.7093 1.84364 18.1967L10.2889 9.83938C10.5387 9.59226 10.8809 9.45441 11.228 9.45784C11.5793 9.46066 11.915 9.60353 12.1606 9.85486L18.9941 16.8435L26.4085 9.81932C26.9375 9.31814 27.7727 9.34084 28.274 9.86973C28.7752 10.3989 28.7526 11.234 28.2236 11.7353L19.8663 19.6527C19.3431 20.1485 18.519 20.1327 18.0153 19.6173L11.2018 12.649L3.70011 20.0726C3.4428 20.3272 3.10727 20.4542 2.77192 20.4542Z",
  fill: "#C6C6C6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0852 14.4282C13.0286 14.4282 14.604 12.8527 14.604 10.9093C14.604 8.9659 13.0286 7.39044 11.0852 7.39044C9.14174 7.39044 7.56628 8.9659 7.56628 10.9093C7.56628 12.8527 9.14174 14.4282 11.0852 14.4282Z",
  fill: "#C6C6C6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1785 22.3457C21.122 22.3457 22.6974 20.7702 22.6974 18.8268C22.6974 16.8834 21.122 15.3079 19.1785 15.3079C17.2351 15.3079 15.6597 16.8834 15.6597 18.8268C15.6597 20.7702 17.2351 22.3457 19.1785 22.3457Z",
  fill: "#C6C6C6"
});

var SvgConnectedBall = function SvgConnectedBall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnectedBall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connected-ball.1e1b7215.svg";
export { ForwardRef as ReactComponent };